import { render, staticRenderFns } from "./GDNPage.vue?vue&type=template&id=f64673dc&scoped=true&"
import script from "./GDNPage.vue?vue&type=script&lang=js&"
export * from "./GDNPage.vue?vue&type=script&lang=js&"
import style0 from "./GDNPage.vue?vue&type=style&index=0&id=f64673dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64673dc",
  null
  
)

export default component.exports